import React from 'react';
import { connect } from 'react-redux';
import { createChildren } from '../Box/createChildren';
export const SingleObjectMediaBase = ({ objectName, birdElements }) => {
    return (React.createElement("div", { style: {
            display: 'flex',
            justifyContent: 'stretch',
            flexDirection: 'row',
            flexGrow: 1,
        } }, objectName
        ? createChildren([objectName], birdElements, {
            includePreferredSizing: true,
            style: { flexGrow: 1, flexShrink: 1 },
        })
        : null));
};
export const SingleObjectMedia = connect((state, props) => {
    const layoutData = state.ui.birdLayout.byId[props.id];
    return {
        birdElements: state.birdElements,
        objectName: layoutData && layoutData.childKeys ? layoutData.childKeys[0] : undefined,
    };
})(SingleObjectMediaBase);
